import type { IExtractParams } from "@/routes";
import { apiPathFunc } from "@api/util/apiPathFunc";

const pathBase = `/courses/:courseId/exams/file-based/attempts/latest`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const latest = {
  getAll: apiPathFunc(pathBase),
} as const;
